import { Component, OnInit } from '@angular/core';

import { Local, LocalCombustivel } from "../shared/local.model";
import { locaisModuleName } from "../shared/data.service";
import { LocalApiService } from "../shared/local-api.service";
import { LocalNavigationService } from "../shared/local-navigation.service";
import { UtilService } from "../../../shared/services/util.service";
import { LocalService } from "../shared/local.service";
import { AbastecimentoService } from "../../shared/abastecimento.service";
import {abastecimentosModuleName} from "../../shared/data.service";
import {configuracaoModuleName} from "../../../shared/services/data.service";

@Component({
    template: require('./local-list.component.html'),
    styles: [require('./local-list.component.css')]
})
export class LocalListComponent implements OnInit {
    list: any[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    locaisModuleName: any = locaisModuleName;
    module: any = abastecimentosModuleName;
    configuracaoModule: any = configuracaoModuleName;

    localCombustiveis: LocalCombustivel[] = [];

    constructor(
        private _locaisApiService: LocalApiService,
        private _localService: LocalService,
        private _localNavigationService: LocalNavigationService,
        private _utilService: UtilService,
        private _abastecimentoService: AbastecimentoService
    ) { }

    ngOnInit() {
        this.getAll();
        this.getAllLocalCombustivel();
    }

    clickNew() {
        this._localService.clearSessionStorage();
        this._localNavigationService.goToNew();
    }

    clickGoToSettings() {
        this._abastecimentoService.goToSetting();
    }

    clickEdit(item: Local) {
        this._localService.clearSessionStorage();
        this._localNavigationService.goToEdit(item.id);
    }

    clickDelete(item: Local) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private getAll() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number;
                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    Response[x].tipo = this._localService.getTipoLocal(Response[x].tipo);
                    Response[x].combustiveis = [];
                }

                this.list = Response;
                if (this.localCombustiveis.length) {
                    this.setLocaisCombustiveis();
                }
            }
            this.loading = false;
        }.bind(this));

        this._locaisApiService.onGetAll(onDone);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._locaisApiService.onDelete(item.id, onDone);
    }

    private getAllLocalCombustivel() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.localCombustiveis = Response;
                if (this.list.length) {
                    this.setLocaisCombustiveis();
                }
            }
            this.loading = false;
        }.bind(this));

        this._locaisApiService.onGetAllLocalCombustivel(onDone);
    }

    private setLocaisCombustiveis() {
        let x: number, lenX: number,
            y: number, lenY: number;

        for (x = 0, lenX = this.list.length; x < lenX; x++) {
            for (y = 0, lenY = this.localCombustiveis.length; y < lenY; y++) {
                if (this.list[x].id === this.localCombustiveis[y].localId) {
                    this.list[x].combustiveis.push(this.localCombustiveis[y]);
                }
            }
        }
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/locais/local-list/local-list.component.ts
 **/